import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentStep: 1,
  formData: {},
  formStructure: {},
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    setStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setFormStructure: (state, action) => {
      state.formStructure = action.payload || {};
    },
    setFormData: (state, action) => {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    removeFormField: (state, action) => {
      const name = action.payload;
      delete state.formData[name];
    },
    resetFormData: (state) => {
      state.formData = {};
      state.formStructure = {};
      state.setStep = 1;
    },
  },
});

export const {
  setFormStructure,
  setFormData,
  setStep,
  removeFormField,
  resetFormData,
} = formSlice.actions;

export default formSlice.reducer;
